import React, { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0));
  }, []);

  return (
    <div className="min-h-screen pt-20" style={{ background: "#0A0E17" }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="space-y-8" style={{ color: "#8B95A8" }}>
          <div className="space-y-2">
            <h1 className="text-4xl font-bold" style={{ color: "#F1F5F9" }}>Privacy Policy</h1>
            <p style={{ color: "#4A5568" }}>
              Our Privacy Policy is effective as of January 19th, 2024
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>INTRODUCTION</h2>
            <p>
              Parlaye, Inc. carrying on business as Parlaye ("Parlaye," "we,"
              "us," "our") respects your privacy and is committed to protecting
              it by providing and complying with this Privacy Policy.
            </p>
            <p>
              Throughout this Privacy Policy, "Personal Information" means
              information that we can reasonably use to directly or indirectly
              identify you, such as your name, date of birth, country of origin,
              mailing address, e-mail address, telephone number, Internet
              protocol (IP) address used to connect your computer to the
              Internet, user name or other similar identifier, your age or other
              identifying information, and any other identifier we may use to
              contact you; as well as information about any businesses for which
              you engage Parlaye's services to design and develop brands.
            </p>
            <p>This Privacy Policy describes:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                How we collect, use, disclose, and protect the Personal
                Information of our customers and users ("you").
              </li>
              <li>
                The types of Personal Information we may collect from you or
                that you may provide when you visit our product page at
                www.parlaye.com and register for, download and install the
                Parlaye App (collectively the "App").
              </li>
              <li>
                Our practices for collecting, using, maintaining, protecting,
                and disclosing that Personal Information.
              </li>
              <li>
                The right of users to access their personal information and
                request corrections if the information is inaccurate
              </li>
            </ul>
            <p>
              Please read this Privacy Policy carefully to understand our
              policies and practices for collecting, processing, and storing
              your Personal Information. If you do not agree with our policies
              and practices, your choice is not to use our App. By accessing or
              using our App, you indicate that you understand, accept, and
              consent to the practices described in this Privacy Policy. This
              Privacy Policy may change from time to time (see Changes to Our
              Privacy Policy).
            </p>
            <p>
              Your continued use of our App after we make changes indicates that
              you accept and consent to those changes, so please check the
              Privacy Policy periodically for updates. We will notify you in
              advance of any material changes to this Privacy Policy and obtain
              your consent to any new ways that we collect, use, and disclose
              your Personal Information.
            </p>
            <p>
              We will only use your Personal Information in accordance with this
              Privacy Policy unless otherwise required by Applicable Law
              (defined below). We take steps to ensure that the Personal
              Information that we collect about you is adequate, relevant, not
              excessive, and used for limited purposes.
            </p>
            <p>
              This Privacy Policy is designed to provide transparency regarding
              Parlaye's privacy policies with respect to your Personal
              Information we collect from you when you use our App, in
              accordance with the rules and protections around such information
              under Applicable Law.
            </p>
            <p>
              This Privacy Policy applies to Personal Information we collect,
              use, or disclose about you:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>on our App;</li>
              <li>
                in email, text, and other electronic messages between you and
                us;
              </li>
              <li>
                through links to third-party websites, plug-ins, services,
                social networks, or applications. Clicking on those links or
                enabling those connections may allow the third party to collect
                or share data about you. If you follow a link to a third-party
                website or engage a third-party plugin, please note that these
                third parties have their own privacy policies and we do not
                accept any responsibility or liability for these policies. We do
                not control these third-party websites, and we encourage you to
                read the privacy policy of every website you visit.
              </li>
            </ul>
            <p>
              This Privacy Policy DOES NOT apply to Personal Information that:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                we collect offline or through any other means, including on any
                other Parlaye or third-party website or mobile application
                (including our affiliates and subsidiaries); or
              </li>
              <li>
                you provide to or that is collected by any third party
                (including our affiliates and subsidiaries), through any
                application or content (including advertising) that may link to
                or be accessible from or on our App.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>DEFINITIONS</h2>
            <p>
              Capitalized terms in this Privacy Policy, where not defined below,
              shall have the same meaning as in the Parlaye's Terms of Use
              ("Terms and Conditions"). In addition:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                "Applicable Law" means (for so long as and to the extent that
                they apply to the App) the laws of the U.S. and Canada.
              </li>
              <li>
                "California Policy" means the policy at Schedule "A" below,
                applicable to California residents.
              </li>
              <li>
                "User" refers to a person or entity that has been granted access
                to the App and who has agreed to be bound by the Terms.
              </li>
              <li>
                "User Contributions" refers to content that has been contributed
                to by users of the application, including personal information.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              INFORMATION WE COLLECT ABOUT YOU
            </h2>
            <p>
              We collect and use several types of information from and about
              you, including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Personal Information. As defined above.</li>
              <li>
                Payment information, including credit card or other mode of
                payment data. Financial transactions relating to our App, as and
                when they are offered, will be handled by our third party
                payment services providers. We will share transaction data with
                our payment services providers only to the extent necessary for
                the purposes of processing your payments and related
                transactions.
              </li>
              <li>
                Non-personal information, that does not directly or indirectly
                reveal your identity or directly relate to an identifiable
                individual, such as geolocation data, generalized data,
                demographic information, or statistical or aggregated
                information. Statistical or aggregated data does not directly
                identify a specific person, but we may derive non-personal
                statistical or aggregated data from Personal Information. For
                example, we may aggregate Personal Information to calculate the
                percentage of users accessing a specific App feature.
              </li>
              <li>
                Technical information, including your login information, device
                type, browser type and version, time zone setting, browser
                plug-in types and versions, operating system and platform, or
                information about your internet connection, the equipment you
                use to access our App, App pages viewed, sections of the App
                used or viewed, and usage details.
              </li>
              <li>
                Non-personal details about your App interactions, including the
                full Uniform Resource Locators (URLs), clickstream to, through
                and from our App (including date and time), products you viewed
                or searched for, page response times, download errors, length of
                visits to certain pages, page interaction information (such as
                scrolling, clicks, and mouse-overs), or methods used to browse
                away from the App.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              HOW WE COLLECT INFORMATION ABOUT YOU
            </h2>
            <h3 className="text-xl font-semibold text-white mt-4">
              Methods of Collection
            </h3>
            <p>
              We use different methods to collect your Personal Information,
              including through:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Direct interactions with you when you provide it to us, for
                example, by filling in forms, registering for an account, or
                corresponding with us by phone, email, or otherwise.
              </li>
              <li>
                User Contributions. You may also provide information to be
                published or displayed (hereinafter, "posted") in public or
                shared areas of the App or transmitted to other users of the App
                or third parties (collectively, "User Contributions").
              </li>
              <li>
                Automated technologies or interactions, as you navigate through
                our App. Information collected automatically may include usage
                details, IP addresses, and information collected through
                cookies, web beacons, and other tracking technologies.
              </li>
              <li>
                Third parties or publicly available sources, for example, our
                business partners.
              </li>
            </ul>
            <p>
              Your User Contributions are posted on and transmitted to others at
              your own risk. Please be aware that no security measures are
              perfect. Additionally, we cannot control the actions of other
              users of the App with whom you may choose to share your User
              Contributions. Therefore, we cannot and do not guarantee that
              unauthorized persons will not view your User Contributions.
            </p>

            <h3 className="text-xl font-semibold text-white mt-4">
              Information You Provide to Us
            </h3>
            <p>
              The information we collect directly from you on or through our App
              may include:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Information that you provide by filling in forms on our App.
                This includes information provided at the time of subscribing to
                a newsletter, registering through authentication with the App,
                posting material, and/or requesting further services. We may
                also ask you for information when you report a problem with our
                App.
              </li>
              <li>
                Records and copies of your correspondence (including email
                addresses), if you contact us.
              </li>
              <li>
                Your responses to surveys that we might ask you to complete for
                research purposes.
              </li>
              <li>Your search queries on the App.</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-4">
              Information We Collect Through Third Parties
            </h3>
            <p>
              We may collect information about you from third parties with your
              consent, or where otherwise permitted by law. Information
              collected from third parties is used to facilitate the use of the
              App and various features offered on it.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              HOW WE USE YOUR INFORMATION
            </h2>
            <p>
              We use information that we collect about you or that you provide
              to us, including any Personal Information:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>to present our App and its contents to you;</li>
              <li>to facilitate contests on the App;</li>
              <li>
                to provide you with information, products, or services that you
                request from us or that we may consider of interest to you;
              </li>
              <li>
                to fulfill the purposes for which you provided the information
                or that were described when it was collected, or any other
                purpose for which you provide it;
              </li>
              <li>
                to carry out our obligations and enforce our rights arising from
                any contracts with you, or to comply with legal requirements;
              </li>
              <li>
                to notify you by email or other means about changes to our App
                or any products or services we offer or provide through it;
              </li>
              <li>
                to improve our App, products or services, marketing, or customer
                relationships and experiences. For this purpose, we may
                calculate active users, daily user engagements and duration of
                each, App status and maintenance, version adoption, acquired
                users, user retention (weeks, percentage of users), audience
                metrics, country of access and other relevant data;
              </li>
              <li>
                to allow you to participate in interactive features, social
                media, or similar features on our App;
              </li>
              <li>
                to measure or understand the effectiveness of the advertising we
                serve to you and others, and to deliver relevant advertising to
                you;
              </li>
              <li>
                to create de-identified data and aggregated data and statistics;
              </li>
              <li>
                in any other way we may describe when you provide the
                information; or
              </li>
              <li>for any other purpose with your consent.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              DISCLOSURE OF YOUR INFORMATION
            </h2>
            <p>
              We may disclose aggregated information about our users, and
              information that does not identify any individual, without
              restriction.
            </p>
            <p>
              We may disclose Personal Information that we collect or you
              provide as described in this Privacy Policy:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>to our subsidiaries and affiliates;</li>
              <li>
                in accordance with Applicable Law, to a buyer or other successor
                in the event of a merger, divestiture, restructuring,
                reorganization, dissolution, or other sale or transfer of some
                or all of Parlaye's assets, whether as a going concern or as
                part of bankruptcy, liquidation, or similar proceeding, in which
                Personal Information held by Parlaye about our customers and
                users is among the assets transferred;
              </li>
              <li>
                to Company personnel including but not limited to executive and
                management personnel and employees including developers,
                designers, researchers, data engineers;
              </li>
              <li>
                to contractors, service providers, and other third parties we
                use to support our business (such as analytics and search engine
                providers that assist us with App improvement and optimization)
                and who are contractually obligated to keep Personal Information
                confidential, use it only for the purposes for which we disclose
                it to them, and to process the Personal Information with the
                same standards set out in this Privacy Policy;
              </li>
              <li>to fulfill the purpose for which you provide it;</li>
              <li>
                for any other purpose disclosed by us when you provide the
                information; or
              </li>
              <li>with your consent.</li>
            </ul>
            <p>We may also disclose your Personal Information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                to comply with any court order, law, or legal process, including
                to respond to any government or regulatory request, in
                accordance with Applicable Law;
              </li>
              <li>
                to enforce or apply our Terms of Use and other agreements,
                including for billing and collection purposes; or
              </li>
              <li>
                if we believe disclosure is necessary or appropriate to protect
                the rights, property, or safety of Parlaye, our customers, or
                others. This includes exchanging information with other
                companies and organizations for the purposes of fraud protection
                and credit risk reduction.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              TRANSFERRING YOUR PERSONAL INFORMATION
            </h2>
            <p>
              We may transfer Personal Information that we collect or that you
              provide as described in this Privacy Policy to contractors,
              service providers, and other third parties we use to support our
              business (such as analytics and search engine providers that
              assist us with App improvement and optimization), and who we shall
              contractually require to keep such Personal Information
              confidential on terms no less protective than the terms in this
              Privacy Policy. Such third parties may use it only for the
              purposes for which we disclose it to them, and are required to
              store and process the Personal Information with the same standards
              of care set out in this Privacy Policy.
            </p>
            <p>
              We may process, store, and transfer your Personal Information in
              and to a foreign country. In these circumstances, the governments,
              courts, law enforcement, or regulatory agencies of that country
              may be able to obtain access to your Personal Information through
              the laws of the foreign country. Whenever we engage a service
              provider, we require that its privacy and security standards
              adhere to this Privacy Policy and all Applicable Law. By
              submitting your Personal Information or engaging with the App, you
              consent to this transfer, storage, or processing.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION
            </h2>
            <p>
              We strive to provide you with choices regarding the Personal
              Information you provide to us. We have created mechanisms to
              provide you with control over your information.
            </p>
            <p>
              If you have opted in to receive certain emails from us but no
              longer wish to have your email address used by Parlaye to promote
              our own or third parties' products or services, you can opt-out by
              checking the relevant box located on the form on which we collect
              your data or at any other time by sending us an email stating your
              request to support@parlaye.com. If we have sent you a promotional
              email, you may unsubscribe by clicking the unsubscribe link we
              have included in the email.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>DATA SECURITY</h2>
            <p>
              The security of your Personal Information is very important to us.
              We use physical, electronic, and administrative measures designed
              to secure your Personal Information from accidental loss and from
              unauthorized access, use, alteration, and disclosure. We store all
              information you provide to us behind firewalls on our secure
              servers.
            </p>
            <p>
              The safety and security of your Personal Information also depends
              on you. Where we have given you (or where you have chosen) a
              password for access to certain parts of our App, you are
              responsible for keeping this password confidential. We ask you not
              to share your password with anyone. We urge you to be careful
              about giving out information in public areas of the App like
              message boards, which any App visitor can view.
            </p>
            <p>
              Unfortunately, the transmission of information via the Internet is
              not completely secure. Although we do our best to protect your
              Personal Information, we cannot guarantee the security of your
              Personal Information transmitted to our App. Any transmission of
              Personal Information is at your own risk. We are not responsible
              for circumvention of any privacy settings or security measures
              contained on the App.
            </p>
            <p>
              Further, should you choose to print out or otherwise replicate
              Personal Information you have submitted to the App, Parlaye will
              not be responsible for any consequent dissemination or loss of
              such replicated Personal Information. Parlaye's data security
              measures cannot be extended to physical copies or other
              representations or replicas of Personal Information created or
              derived by you, from the App.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              DATA RETENTION
            </h2>
            <p>
              Except as otherwise permitted or required by Applicable Law or
              regulation, we will only retain your Personal Information for as
              long as necessary to fulfill the purposes we collected it for,
              including for the purposes of satisfying any legal, accounting, or
              reporting requirements.
            </p>
            <p>
              Under some circumstances, we may anonymize your Personal
              Information so that it can no longer be associated with you. We
              reserve the right to use such anonymous and de-identified data for
              any legitimate business purpose without further notice to you or
              your consent.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              CHILDREN UNDER THE AGE OF 13
            </h2>
            <p>
              Our App is not intended to be used by children under 13 years of
              age. No one under age 13 may provide any information to or on the
              App. We do not knowingly collect Personal Information from
              children under 13. If you are under 13, do not use or provide any
              information on this App or on or through any of its
              features/register on the App, use any of the interactive or public
              comment features of this App, or provide any information about
              yourself to us, including your name, address, telephone number,
              email address, or any screen name or username you may use. If we
              learn we have collected or received Personal Information from a
              child under 13 without verification of parental consent, we will
              delete that information. If you believe we might have any
              information from or about a child under 13, please contact us at
              support@parlaye.com.
            </p>
            <p>
              When it comes to the collection of personal information from
              children under the age of 13 years old, the U.S. Children's Online
              Privacy Protection Act (COPPA) puts parents in control. The
              Federal Trade Commission, the United States' consumer protection
              agency, enforces the COPPA Rule, which spells out what operators
              of websites and online services must do to protect children's
              privacy and safety online.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              AUTHORIZED USERS IN CALIFORNIA
            </h2>
            <p>
              If you are a California resident, California law may provide you
              with specific rights regarding our use of your personal
              information. To learn more about your California privacy rights,
              visit https://oag.ca.gov/privacy/ccpa.
            </p>
            <p>
              Schedule "A" to this Privacy Policy contains terms applicable
              specifically to California residents who use the App as Users
              ("California Policy"). Many parts of the California Policy are
              identical to those in this Privacy Policy. To the extent possible,
              the California Policy should be read in harmony with this Privacy
              Policy, and if there is any conflict between the two, the
              California Policy shall prevail in relation to any California
              resident's use of the App as Users.
            </p>
            <p>
              California's "Shine the Light" law (Civil Code Section § 1798.83)
              and the California Consumer Privacy Act of 2018 ("CCPA") permits
              users of the App that are California residents to request certain
              information regarding our disclosure of personal information to
              third parties for their direct marketing purposes. To make such a
              request, please send an e-mail to us at support@parlaye.com.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              ACCESSING AND CORRECTING YOUR PERSONAL INFORMATION
            </h2>
            <p>
              It is important that the Personal Information we hold about you is
              accurate and current. Please keep us informed if your Personal
              Information changes. By law you have the right to request access
              to and to correct the Personal Information that we hold about you.
            </p>
            <p>
              If you want to review, verify, correct, or withdraw consent to the
              use of your Personal Information you may also send us an email at
              support@parlaye.com to request access to, correct, or delete any
              Personal Information that you have provided to us. We may not
              accommodate a request to change information if we believe the
              change would violate any law or legal requirement or cause the
              information to be incorrect. All requests will be responded to
              within 20 days of receipt.
            </p>
            <p>
              We may request specific information from you to help us confirm
              your identity and your right to access, and to provide you with
              the Personal Information that we hold about you or make your
              requested changes. Applicable Law may allow or require us to
              refuse to provide you with access to some or all of the Personal
              Information that we hold about you, or we may have destroyed,
              erased, or made your Personal Information anonymous in accordance
              with our record retention obligations and practices. If we cannot
              provide you with access to your Personal Information, we will
              inform you of the reasons why, subject to any legal or regulatory
              restrictions.
            </p>
            <p>
              We will provide access to your Personal Information, subject to
              exceptions set out in applicable privacy legislation. Examples of
              such exceptions include:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Information protected by solicitor-client privilege.</li>
              <li>
                Information that is part of a formal dispute resolution process.
              </li>
              <li>
                Information that is about another individual that would reveal
                their Personal Information or confidential commercial
                information.
              </li>
              <li>Information that is prohibitively expensive to provide.</li>
            </ul>
            <p>
              If you are concerned about our response or would like to correct
              the information provided, you may contact us at
              support@parlaye.com.
            </p>
            <p>
              If you delete your User Contributions from the App, copies of your
              User Contributions may remain viewable in cached and archived
              pages or might have been copied or stored by other App users.
              Proper access and use of information provided on the App,
              including User Contributions, is governed by our Terms of Use.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              WITHDRAWING YOUR CONSENT
            </h2>
            <p>
              Where you have provided your consent to the collection, use, and
              transfer of your Personal Information, you may have the legal
              right to withdraw your consent under certain circumstances. To
              withdraw your consent, if applicable, contact us at
              support@parlaye.com. Please note that if you withdraw your consent
              we may not be able to provide you with a particular product or
              service.
            </p>
            <p>
              We will explain the impact to you at the time to help you with
              your decision.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              DELETING YOUR ACCOUNT
            </h2>
            <p>
              If you want to permanently delete your account, including any
              Personal Information that you have provided to us, you must send
              us an email at support@parlaye.com. We may request specific
              information from you to help us confirm your identity and your
              desire to permanently delete your account (such as an email or
              phone number already associated with the account).
            </p>
            <p>
              We may not accommodate a request to delete all personal
              information if we believe it would violate any law or legal
              requirement.
            </p>
            <p>
              If you have a money balance in your account, we will provide you
              with the step for refund. Please note that refunds are subject to
              our TOU unless otherwise agreed.
            </p>
            <p>
              All requests will be responded to within 20 days of receipt and we
              will provide a confirmation when the deletion has been completed.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              CHANGES TO OUR PRIVACY POLICY
            </h2>
            <p>
              It is our policy to post any changes we make, or are required to
              make to our Privacy Policy on this page. If we make material
              changes to how we treat our users' Personal Information, we will
              notify you through a notice on the App home page.
            </p>
            <p>
              We include the date the Privacy Policy was last revised at the top
              of the page. You are responsible for ensuring we have an
              up-to-date, active, and deliverable email address for you, and for
              periodically visiting our App and this Privacy Policy to check for
              any changes.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              CONTACT INFORMATION AND CHALLENGING COMPLIANCE
            </h2>
            <p>
              We welcome your questions, comments, and requests regarding this
              Privacy Policy and our privacy practices. Please contact us at:
              Privacy Officer support@parlaye.com
            </p>
            <p>
              We have procedures in place to receive and respond to complaints
              or inquiries about our handling of Personal Information, our
              compliance with this Privacy Policy, and with applicable privacy
              laws. To discuss our compliance with this Privacy Policy please
              contact us using the contact information listed above.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold" style={{ color: "#F1F5F9" }}>
              SCHEDULE "A" CALIFORNIA POLICY
            </h2>
            <p>
              This Privacy Policy for California Residents ("California Policy")
              supplements the Parlaye (the "Company," "we", "us", "our(s)") main
              Privacy Policy and applies solely to all visitors, users, and
              others who reside in the State of California ("consumers" or
              "you"). We adopt this notice to comply with the California
              Consumer Privacy Act of 2018 ("CCPA") and any terms defined in the
              CCPA have the same meaning when used in this California Policy
            </p>
            <p>
              This California Policy does not apply to workforce-related
              personal information collected from California-based employees,
              job applicants, contractors, or similar individuals.
            </p>
            <p>
              Where noted in this California Policy, the CCPA temporarily
              exempts personal information reflecting a written or verbal
              business-to-business communication ("B2B personal information")
              from some of its requirements.
            </p>

            <h3 className="text-xl font-semibold text-white mt-4">
              Information We Collect
            </h3>
            <p>
              We collect information that identifies, relates to, describes,
              references, is reasonably capable of being associated with, or
              could reasonably be linked, directly or indirectly, with a
              particular consumer, household, or device ("personal
              information"). Personal information does not include:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Publicly available information from government records.</li>
              <li>Deidentified or aggregated consumer information.</li>
              <li>
                Information excluded from the CCPA's scope, like:
                <ul className="list-disc pl-6 space-y-2 mt-2">
                  <li>
                    health or medical information covered by the U.S. Health
                    Insurance Portability and Accountability Act of 1996 (HIPAA)
                    and the California Confidentiality of Medical Information
                    Act (CMIA), clinical trial data, or other qualifying
                    research data;
                  </li>
                  <li>
                    personal information covered by certain sector-specific
                    privacy laws, including the U.S. Fair Credit Reporting Act
                    (FCRA), the Gramm-Leach-Bliley Act (GLBA) or California
                    Financial Information Privacy Act (FIPA), and the Driver's
                    Privacy Protection Act of 1994.
                  </li>
                </ul>
              </li>
            </ul>
            <p>
              In particular, we have collected the following categories of
              personal information from consumers within the last twelve (12)
              months:
            </p>

            <div className="overflow-x-auto mt-4">
              <table className="min-w-full bg-gray-800 border border-gray-700">
                <thead>
                  <tr>
                    <th className="px-4 py-2 border-b border-gray-700 text-left">
                      Category
                    </th>
                    <th className="px-4 py-2 border-b border-gray-700 text-left">
                      Examples
                    </th>
                    <th className="px-4 py-2 border-b border-gray-700 text-left">
                      Collected
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      A. Identifiers.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      A real name, alias, postal address, unique personal
                      identifier, online identifier, Internet Protocol address,
                      email address, account name, or other similar identifiers.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">YES</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      B. Personal information categories listed in the
                      California Customer Records statute (Cal. Civ. Code §
                      1798.80(e)).
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      A name, signature, address, telephone number, passport
                      number, driver's license or state identification card
                      number, bank account number, credit card number, debit
                      card number, or any other financial information. Some
                      personal information included in this category may overlap
                      with other categories.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">YES</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      C. Protected classification characteristics under
                      California or federal law.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Age (40 years or older), race, color, ancestry, national
                      origin, citizenship, religion or creed, marital status,
                      medical condition, physical or mental disability, sex
                      (including gender, gender identity, gender expression,
                      pregnancy or childbirth and related medical conditions),
                      sexual orientation, veteran or military status, genetic
                      information (including familial genetic information).
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">NO</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      D. Commercial information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Records of personal property, products or services
                      purchased, obtained, or considered, or other purchasing or
                      consuming histories or tendencies.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">NO</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      E. Biometric information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Genetic, physiological, behavioral, and biological
                      characteristics, or activity patterns used to extract a
                      template or other identifier or identifying information,
                      such as, fingerprints, faceprints, and voiceprints, iris
                      or retina scans, keystroke, gait, or other physical
                      patterns, and sleep, health, or exercise data.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">NO</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      F. Internet or other similar network activity.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Browsing history, search history, information on a
                      consumer's interaction with a website, application, or
                      advertisement.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">YES</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      G. Geolocation data.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Physical location or movements.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">YES</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      H. Sensory data.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Audio, electronic, visual, thermal, olfactory, or similar
                      information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">NO</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      I. Professional or employment-related information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Current or past job history or performance evaluations.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">NO</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      J. Non-public education information (per the Family
                      Educational Rights and Privacy Act (20 U.S.C. Section
                      1232g, 34 C.F.R. Part 99)).
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Education records directly related to a student maintained
                      by an educational institution or party acting on its
                      behalf, such as grades, transcripts, class lists, student
                      schedules, student identification codes, student financial
                      information, or student disciplinary records.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">NO</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b border-gray-700">
                      K. Inferences drawn from other personal information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Profile reflecting a person's preferences,
                      characteristics, psychological trends, predispositions,
                      behavior, attitudes, intelligence, abilities, and
                      aptitudes.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">NO</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mt-4">
              We obtain the categories of personal information listed above from
              the following categories of sources:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Directly from you. For example, from forms you complete or
                products and services you purchase.
              </li>
              <li>
                Indirectly from you. For example, from observing your actions on
                our App.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-4">
              Use of Personal Information
            </h3>
            <p>
              We may use or disclose the personal information we collect for one
              or more of the following purposes:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                To fulfill or meet the reason you provided the information. For
                example, if you share your name and contact information to
                request a price quote or ask a question about our products or
                services, we will use that personal information to respond to
                your inquiry. If you provide your personal information to
                purchase a product or service, we will use that information to
                process your payment and facilitate delivery. We may also save
                your information to facilitate new product orders or process
                returns.
              </li>
              <li>
                To provide, support, personalize, and develop our App, products,
                and services.
              </li>
              <li>
                To create, maintain, customize, and secure your account with us.
              </li>
              <li>
                To process your requests, purchases, transactions, and payments
                and prevent transactional fraud.
              </li>
              <li>
                To provide you with support and to respond to your inquiries,
                including to investigate and address your concerns and monitor
                and improve our responses.
              </li>
              <li>
                To personalize your App experience and to deliver content and
                product and service offerings relevant to your interests,
                including targeted offers and ads through our App, third-party
                sites, and via email or text message (with your consent, where
                required by law).
              </li>
              <li>
                To help maintain the safety, security, and integrity of our App,
                products and services, databases and other technology assets,
                and business.
              </li>
              <li>
                For testing, research, analysis, and product development,
                including to develop and improve our App, products, and
                services.
              </li>
              <li>
                To respond to law enforcement requests and as required by
                Applicable Law, court order, or governmental regulations.
              </li>
              <li>
                As described to you when collecting your personal information or
                as otherwise set forth in the CCPA.
              </li>
              <li>
                To evaluate or conduct a merger, divestiture, restructuring,
                reorganization, dissolution, or other sale or transfer of some
                or all of our assets, whether as a going concern or as part of
                bankruptcy, liquidation, or similar proceeding, in which
                personal information held by us about our App users is among the
                assets transferred.
              </li>
            </ul>
            <p>
              We will not collect additional categories of personal information
              or use the personal information we collected for materially
              different, unrelated, or incompatible purposes without providing
              you notice.
            </p>

            <h3 className="text-xl font-semibold text-white mt-4">
              Sharing Personal Information
            </h3>
            <p>
              We may share your personal information by disclosing it, in both
              original or anonymized form, to a third party for a business
              purpose. If you wish to specifically opt out of this sharing,
              please email us at support@parlaye.com.
            </p>
            <p>
              We only make business purpose disclosures under written contracts
              that describe the purposes, require the recipient to keep the
              personal information confidential, and prohibit using the
              disclosed information for any purpose except performing the
              contract. In the preceding twelve (12) months, the Company has
              disclosed personal information for a business purpose to the
              categories of third parties indicated in the chart below.
            </p>
            <p>We do not sell personal information.</p>

            <div className="overflow-x-auto mt-4">
              <table className="min-w-full bg-gray-800 border border-gray-700">
                <thead>
                  <tr>
                    <th
                      rowSpan="2"
                      className="w-2/4 px-4 py-2 border-b border-gray-700 text-left"
                    >
                      Personal Information Category
                    </th>
                    <th
                      colSpan="2"
                      className="px-4 py-2 border-b border-gray-700 text-left"
                    >
                      Category of Third-Party Recipients
                    </th>
                  </tr>
                  <tr>
                    <th className="px-4 py-2 border-b border-gray-700 text-left">
                      Business Purpose Disclosures
                    </th>
                    <th className="px-4 py-2 border-b border-gray-700 text-left">
                      Sales
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      A: Identifiers.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Registration and use of the App.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      B: California Customer Records personal information
                      categories.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Registration and use of the App.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      C: Protected classification characteristics under
                      California or federal law.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Registration and use of the App.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      D: Commercial information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Registration and use of the App.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      E: Biometric information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      F: Internet or other similar network activity.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Registration and use of the App.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      G: Geolocation data.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      H: Sensory data.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      I: Professional or employment-related information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      J: Non-public education information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                  <tr>
                    <td className="w-2/4 px-4 py-2 border-b border-gray-700">
                      K: Inferences drawn from other personal information.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      Registration and use of the App.
                    </td>
                    <td className="px-4 py-2 border-b border-gray-700">
                      None.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-xl font-semibold text-white mt-4">
              Your Rights and Choices
            </h3>
            <p>
              The CCPA provides California residents with specific rights
              regarding their personal information. This section describes your
              CCPA rights and explains how to exercise those rights.
            </p>

            <h4 className="text-lg font-semibold text-white mt-4">
              Right to Know and Data Portability
            </h4>
            <p>
              You have the right to request that we disclose certain information
              to you about our collection and use of your personal information
              over the past 12 months (the "right to know"). Once we receive
              your request and confirm your identity, we will disclose to you:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                The categories of personal information we collected about you.
              </li>
              <li>
                The categories of sources for the personal information we
                collected about you.
              </li>
              <li>
                Our business or commercial purpose for collecting or selling
                that personal information.
              </li>
              <li>
                The categories of third parties with whom we share that personal
                information.
              </li>
              <li>
                If we sold or disclosed your personal information for a business
                purpose, two separate lists disclosing:
                <ul className="list-disc pl-6 space-y-2 mt-2">
                  <li>
                    sales, identifying the personal information categories that
                    each category of recipient purchased; and
                  </li>
                  <li>
                    disclosures for a business purpose, identifying the personal
                    information categories that each category of recipient
                    obtained.
                  </li>
                </ul>
              </li>
              <li>
                The specific pieces of personal information we collected about
                you (also called a data portability request).
              </li>
            </ul>
            <p>
              We do not provide a right to know or data portability disclosure
              for B2B personal information.
            </p>

            <h4 className="text-lg font-semibold text-white mt-4">
              Right to Delete
            </h4>
            <p>
              You have the right to request that we delete any of your personal
              information that we collected from you and retained, subject to
              certain exceptions (the "right to delete"). Once we receive your
              request and confirm your identity, we will review your request to
              see if an exception allowing us to retain the information applies.
              We may deny your deletion request if retaining the information is
              necessary for us or our service provider(s) to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Complete the transaction for which we collected the personal
                information, provide a good or service that you requested, take
                actions reasonably anticipated within the context of our ongoing
                business relationship with you, fulfill the terms of a written
                warranty or product recall conducted in accordance with federal
                law, or otherwise perform our contract with you.
              </li>
              <li>
                Detect security incidents, protect against malicious, deceptive,
                fraudulent, or illegal activity, or prosecute those responsible
                for such activities.
              </li>
              <li>
                Debug products to identify and repair errors that impair
                existing intended functionality.
              </li>
              <li>
                Exercise free speech, ensure the right of another consumer to
                exercise their free speech rights, or exercise another right
                provided for by law.
              </li>
              <li>
                Comply with the California Electronic Communications Privacy Act
                (Cal. Penal Code § 1546 et. seq.).
              </li>
              <li>
                Enable solely internal uses that are reasonably aligned with
                consumer expectations based on your relationship with us.
              </li>
              <li>Comply with a legal obligation.</li>
              <li>
                Make other internal and lawful uses of that information that are
                compatible with the context in which you provided it.
              </li>
            </ul>
            <p>
              We will delete or deidentify personal information not subject to
              one of these exceptions from our records and will direct our
              service providers to take similar action.
            </p>
            <p>
              We do not provide these deletion rights for B2B personal
              information.
            </p>

            <h4 className="text-lg font-semibold text-white mt-4">
              Exercising Your Rights to Know or Delete
            </h4>
            <p>
              To exercise your rights to know or delete described above, please
              submit a request by emailing us at support@parlaye.com.
            </p>
            <p>
              Only you, or someone legally authorized to act on your behalf, may
              make a request to know or delete related to your personal
              information.
            </p>
            <p>
              You may also make a request to know or delete on behalf of your
              child by the same method.
            </p>
            <p>
              You may only submit a request to know twice within a 12-month
              period. Your request to know or delete must:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Provide sufficient information that allows us to reasonably
                verify you are the person about whom we collected personal
                information or an authorized representative, which may include:
                <ul className="list-disc pl-6 space-y-2 mt-2">
                  <li>
                    Two (2) pieces of government-issued photo from a state,
                    provincial, or federal government.
                  </li>
                  <li>Parental or guardian identification information.</li>
                </ul>
              </li>
              <li>
                Describe your request with sufficient detail that allows us to
                properly understand, evaluate, and respond to it.
              </li>
            </ul>
            <p>
              We cannot respond to your request or provide you with personal
              information if we cannot verify your identity or authority to make
              the request and confirm the personal information relates to you.
            </p>
            <p>
              You do not need to create an account with us to submit a request
              to know or delete. However, we do consider requests made through
              your password protected account sufficiently verified when the
              request relates to personal information associated with that
              specific account.
            </p>
            <p>
              We will only use personal information provided in the request to
              verify the requestor's identity or authority to make it.
            </p>

            <h4 className="text-lg font-semibold text-white mt-4">
              Response Timing and Format
            </h4>
            <p>
              We will confirm receipt of your request within ten (10) business
              days. If you do not receive confirmation within the 10-day
              timeframe, please contact support@parlaye.com.
            </p>
            <p>
              We endeavor to substantively respond to a verifiable consumer
              request within forty-five (45) days of its receipt. If we require
              more time (up to another 45 days), we will inform you of the
              reason and extension period in writing.
            </p>
            <p>
              If you have an account with us, we will deliver our written
              response to that account. If you do not have an account with us,
              we will deliver our written response by mail or electronically, at
              your option.
            </p>
            <p>
              Any disclosures we provide will only cover the 12-month period
              preceding our receipt of your request. The response we provide
              will also explain the reasons we cannot comply with a request, if
              applicable. For data portability requests, we will select a format
              to provide your personal information that is readily usable and
              should allow you to transmit the information from one entity to
              another entity without hindrance.
            </p>
            <p>
              We do not charge a fee to process or respond to your verifiable
              consumer request unless it is excessive, repetitive, or manifestly
              unfounded. If we determine that the request warrants a fee, we
              will tell you why we made that decision and provide you with a
              cost estimate before completing your request.
            </p>

            <h3 className="text-xl font-semibold text-white mt-4">
              Non-Discrimination
            </h3>
            <p>
              We will not discriminate against you for exercising any of your
              CCPA rights. Unless permitted by the CCPA, we will not:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Deny you goods or services.</li>
              <li>
                Charge you different prices or rates for goods or services,
                including through granting discounts or other benefits, or
                imposing penalties.
              </li>
              <li>
                Provide you a different level or quality of goods or services.
              </li>
              <li>
                Suggest that you may receive a different price or rate for goods
                or services or a different level or quality of goods or
                services.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-4">
              Changes to California Policy
            </h3>
            <p>
              We reserve the right to amend this California Policy at our
              discretion and at any time. When we make changes to this
              California Policy, we will post the updated notice on the App and
              update the notice's effective date. Your continued use of our App
              following the posting of changes constitutes your acceptance of
              such changes.
            </p>

            <h3 className="text-xl font-semibold text-white mt-4">
              Contact Information
            </h3>
            <p>
              If you have any questions or comments about this notice, the ways
              in which the Company collects and uses your information described
              here, your choices and rights regarding such use, or wish to
              exercise your rights under California law, please do not hesitate
              to contact us at support@parlaye.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
